import axios from "axios";
import router from "@/router";

var that = this;


let loadingIsShow = null;

const service = axios.create({
	//baseURL: "http://hzc.hrbcft.com/api/",
	//baseURL: "http://197.77.77.203:8022/api/",
	baseURL: "http://123.56.153.64:8001/api/",
	timeout: 30000,
	headers: {
		//"Content-Type": "application/x-www-form-urlencoded",
		"Content-Type": "application/json",
		"api-type": "web",
		// "api-token": token || ''
	},
});

// 请求拦截
service.interceptors.request.use((res) => {
	// 进度条开始
	var token = localStorage.getItem("token")
	res.headers["api-token"] = token||'';
	window.$loadingBar.start();
	return res;
});

// 响应拦截
service.interceptors.response.use((res) => {
	const that = this;
	if (res.status === 200) {
		if (res.data && res.data.code == 200) {
			return Promise.resolve(res.data);
		} else if (res.data.code != 200) {
			if (res.data.code == -103 || res.data.code == -104) {
				router.push({
					path: "/"
				});
				localStorage.clear();
			}
			return Promise.reject(res);
		}
	} else {
		window.$loadingBar.finish();
		return Promise.reject();
	}
});

export const request = (url = "", data = {}, type = "POST") => {
	return new Promise((resolve, reject) => {
		let promise;

		if (type.toUpperCase() === "GET") {
			promise = service({
				url: url + '?lang=zh-cn',
				//url: url,
				params: data,
			});
		} else if (type.toUpperCase() === "POST") {
			promise = service({
				method: "POST",
				url: url + '?lang=zh-cn',
				//url: url,
				data: data,
			});
		}
		promise
			.then((res) => {
				window.$loadingBar.finish();
				resolve(res);
			})
			.catch((err) => {
				window.$loadingBar.finish();
				if (err.data.msg != "请登录") {
					window.$message.info(
						`${err.data.msg}`, {
							closable: true,
							duration: 5000
						}
					)
				}
				return;
				reject(err);
			});
	});
};